import { render } from "./AddAgentSetting.vue?vue&type=template&id=03fac3ef"
import script from "./AddAgentSetting.vue?vue&type=script&lang=js"
export * from "./AddAgentSetting.vue?vue&type=script&lang=js"

import "./AddAgentSetting.vue?vue&type=style&index=0&id=03fac3ef&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__